export const RESET_ERROR_MESSAGES = {
    general: "Failed to reset password. Please contact support",
    ssoOnly: "Your account is configured for SSO login only. Please use the option sign in using Microsoft/OKTA.",
    resetCode: "Invalid password reset code",
    changesPassword: "New password should not be the same as old password."
}

export const COMMON_ERROR_MESSAGES = {
    general: "An internal error occurred during your request!"
}